import { render, staticRenderFns } from "./SuiviPta.vue?vue&type=template&id=27d75c53"
import script from "./SuiviPta.vue?vue&type=script&lang=js"
export * from "./SuiviPta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports